//TRIGGER FUNCTIONS ON WINDOW RESIZE

var onResize = function(event){

    if(isMobile){
        var innerHeight = window.innerHeight;

        $('.hero .texts').css('min-height', innerHeight);
    }

    //SET HERO SVG HEIGHT FOR IE

    var svg = $('.fold .floor-selector svg'),

        svgWidth = svg.width(),

        imgWidth = 1441,

        imgHeight = 900,

        imgRatio = imgHeight / imgWidth;


    if (isMS) {

        console.log(svgWidth);


        svg.css('height', svgWidth * imgRatio);

    }

    // HANDLING MAP SIZES ON TABLE AND MOBILE

    var gmapsLocations = $('.locations-gmaps');

    if(window.innerWidth > 991) {
        gmapsLocations.removeAttr('style');
    }else {
        gmapsLocations.css('padding-top', gmapsLocations.find('.legend-wrap').outerHeight());
    }

    onScroll();
};

$(window).on('resize orientationchange', onResize);